<div class="container-layout">
  <div class="remaining-space">
    <div class="header">
      <div class="header-left">
        <img src="assets/icon/files.svg" alt="" class="h-icon"/>
        <h4><b>{{'GENERAL_TAB.DOCUMENT_STORAGE' | translate}}</b></h4>
      </div>
      <div class="header-right">
        <button class="secondary-button" (click)="exportAllDocuments()">
          <img src="assets/icon/download.svg" alt="Download All" />
          {{'GENERAL_TAB.EXPORT_ALL' | translate}}
        </button>
      </div>
    </div>

    <div class="content-placeholder">
      <div id="navigation-etapes">
        <div class="timeline-container">
          @for (etape of utilService.currentTir?.workflowInstance?.workflowEtapeInstances; track etape; let i = $index) {
            <div class="etape-card"
              [ngClass]="{'item-selected':utilService.currentEtape?.workflowEtapeInstanceId == etape.workflowEtapeInstanceId}">
              <!-- Timeline Number -->
              <div class="timeline-number">
                <div class="number-circle">{{etape.numeroOrdre}}</div>
                @if (i < utilService.currentTir?.workflowInstance?.workflowEtapeInstances.length - 1) {
                  <div class="timeline-line"></div>
                }
              </div>
              <!-- Card Content -->
              <div class="card-container step-drag-zone"
                [class.expanded]="expandedCards()[i]"
                [class.drag-over]="stepDragOver().get(etape.workflowEtapeInstanceId)"
                [attr.data-step-id]="etape.workflowEtapeInstanceId"
                (dragenter)="onStepDragEnter($event, etape.workflowEtapeInstanceId)"
                (dragover)="onStepDragOver($event, etape.workflowEtapeInstanceId)"
                (dragleave)="onStepDragLeave($event, etape.workflowEtapeInstanceId)"
                (drop)="onStepDrop($event, etape.workflowEtapeInstanceId)">
                <div class="card-header" (click)="!stepDragOver().get(etape.workflowEtapeInstanceId) && toggleCard(i, etape)"
                  [style.pointer-events]="stepDragOver().get(etape.workflowEtapeInstanceId) ? 'none' : 'auto'">
                  <div class="card-content">
                    <div class="etape-info">
                      <div class="etape-header">
                        <span class="etape-name" [title]="getStepTitle(etape.nom)">{{getStepTitle(etape.nom)}}</span>
                      </div>
                      <div class="etape-details">
                        <img src="assets/icon/profil-issue.svg" alt="Export" class="ml-0"/>
                        @if (canEditPermission) {
                          <select class="etape-permission-select"
                            [ngModel]="etape.accessPermission"
                            (ngModelChange)="onPermissionChange(etape, $event)"
                            (click)="$event.stopPropagation()"
                            [disabled]="isPermissionUpdating(etape.workflowEtapeInstanceId)"
                            aria-label="Access permission">
                            <option [ngValue]="0">None</option>
                            <option [ngValue]="1">Read</option>
                            <option [ngValue]="2">Read - Write</option>
                          </select>
                        } @else {
                          <span class="etape-permission">{{getAccessPermission(etape)}}</span>
                        }
                        <img src="assets/icon/files.svg" alt="Export" [ngClass]="{ 'img-disabled': getTotalFilesForStep(etape) == 0 }"/>
                        <span
                        [ngClass]="{
                          'etape-files-count': getTotalFilesForStep(etape) > 1,
                          'files-disabled': getTotalFilesForStep(etape) <= 1
                        }"
                          >
                          {{ getTotalFilesForStep(etape) }}
                          {{ getTotalFilesForStep(etape) > 1 ? ('GENERAL_TAB.FILES' | translate) : ('GENERAL_TAB.FILE' | translate) }}
                        </span>
                      </div>
                    </div>
                    <div class="expand-icon">
                      <img
                        [src]="expandedCards()[i] ? 'assets/icon/arrow-up.svg' : 'assets/icon/arrow-down.svg'"
                        class="expand-arrow"
                        >
                      </div>
                    </div>
                  </div>
                  <!-- Contenu dépliable de la card -->
                  @if (expandedCards()[i]) {
                    <div class="card-body">
                      @if (getFolderForStep(etape.workflowEtapeInstanceId); as dossier) {
                        <div class="folder-content">
                          <!-- Actions de l'étape -->
                          <div class="etape-actions pb-2">
                            <button class="secondary-button" (click)="addFilesToStep(etape.workflowEtapeInstanceId,$event)">
                              <img src="assets/icon/add-circle-black.svg" alt="Add Files" />
                              {{'GENERAL_TAB.ADD_FILES' | translate}}
                            </button>
                            <button class="tertiary-button pl-2 pr-2" (click)="addFolderToStep(etape.workflowEtapeInstanceId, $event)">
                              <img src="assets/icon/add-circle-black.svg" alt="Add Folder" />
                              {{'GENERAL_TAB.ADD_FOLDER' | translate}}
                            </button>
                            <button class="primary-button" [ngClass]="{'disabled': !hasSelectedItems(etape.workflowEtapeInstanceId)}" (click)="exportStep(etape, $event)">
                              <img src="assets/icon/download-white.svg" alt="download" />
                              {{'GENERAL_TAB.DOWNLOAD_SELECTIONS' | translate}}
                            </button>
                          </div>
                          <!-- Select All checkbox -->
                          <div class="select-all-section pb-0 mb-0">
                            <label class="checkbox-container">
                              <input type="checkbox"
                                [checked]="isAllSelected(etape.workflowEtapeInstanceId)"
                                [indeterminate]="isIndeterminate(etape.workflowEtapeInstanceId)"
                                (change)="toggleSelectAll(etape.workflowEtapeInstanceId, $event)">
                                <span class="checkmark"></span>
                                <span class="checkbox-label">
                                  {{isAllSelected(etape.workflowEtapeInstanceId) ? ('GENERAL_TAB.UNSELECT_ALL' | translate) : ('GENERAL_TAB.SELECT_ALL' | translate)}}
                                </span>
                              </label>
                            </div>
                            <hr class="mt-0"/>
                            <!-- Section des dossiers -->
                            <div class="folders-section">
                              <!-- Affichage des sous-dossiers -->
                              @if (dossier.sousDossiers && dossier.sousDossiers.length > 0) {
                                <div class="sub-folders">
                                  @for (sousDossier of dossier.sousDossiers; track sousDossier) {
                                    <div class="sub-folder-card"
                                      [class.expanded]="isSubFolderExpanded(sousDossier.dossierId)"
                                      [class.drag-over]="subFolderDragOver().get(sousDossier.dossierId)"
                                      [attr.data-folder-id]="sousDossier.dossierId"
                                      (dragenter)="onSubFolderDragEnter($event, sousDossier.dossierId)"
                                      (dragover)="onSubFolderDragOver($event, sousDossier.dossierId)"
                                      (dragleave)="onSubFolderDragLeave($event, sousDossier.dossierId)"
                                      (drop)="onSubFolderDrop($event, etape.workflowEtapeInstanceId, sousDossier.dossierId)"
                                      >
                                      <div class="sub-folder-header" (click)="toggleSubFolder(sousDossier.dossierId)">
                                        <div class="folder-checkbox" (click)="$event.stopPropagation()">
                                          <label class="checkbox-container" (click)="$event.stopPropagation()">
                                            <input type="checkbox"
                                              [checked]="isItemSelected('folder', sousDossier.dossierId, etape.workflowEtapeInstanceId)"
                                              (change)="toggleItemSelection('folder', sousDossier.dossierId, etape.workflowEtapeInstanceId, $event)"
                                              (click)="$event.stopPropagation()">
                                              <span class="checkmark"></span>
                                            </label>
                                          </div>
                                          <div class="folder-info">
                                            <div class="folder-details">
                                              <div>
                                                <img src="assets/icon/folder_icon.svg"  alt="" />
                                                <span class="folder-name">{{sousDossier.nom}}</span>
                                              </div>
                                              <div class="folder-meta">
                                                <img src="assets/icon/files.svg"  alt="" /> <span [ngClass]="{ 'files-disabled': sousDossier.fichiers.length == 0 }">{{sousDossier.fichiers.length}} {{'GENERAL_TAB.FILES' | translate}}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="folder-actions-inline btn-actions">
                                            <button class="secondary-button" title="Renommer ce dossier" (click)="renameFolder(sousDossier, etape.workflowEtapeInstanceId); $event.stopPropagation()">
                                              <img src="assets/icon/pencil.svg" alt="Edit" />
                                            </button>
                                            <button class="tertiary-button" title="Supprimer ce dossier" (click)="deleteSubFolder(sousDossier, etape.workflowEtapeInstanceId); $event.stopPropagation()">
                                              <img src="assets/icon/delete.svg" alt="Delete" />
                                            </button>
                                          </div>
                                          <div class="folder-chevron">
                                            <i class="fas" [ngClass]="{'fa-chevron-up': isSubFolderExpanded(sousDossier.dossierId), 'fa-chevron-down': !isSubFolderExpanded(sousDossier.dossierId)}"></i>
                                          </div>
                                        </div>
                                        <!-- Fichiers du sous-dossier -->
                                        @if (isSubFolderExpanded(sousDossier.dossierId) && sousDossier.fichiers && sousDossier.fichiers.length > 0) {
                                          <div class="sub-folder-files">
                                            @for (fichier of sousDossier.fichiers; track fichier) {
                                              <div class="file-card">
                                                <div class="file-checkbox">
                                                  <label class="checkbox-container">
                                                    <input type="checkbox"
                                                      [checked]="isItemSelected('file', fichier.fichierId, etape.workflowEtapeInstanceId)"
                                                      (change)="toggleItemSelection('file', fichier.fichierId, etape.workflowEtapeInstanceId, $event)">
                                                      <span class="checkmark"></span>
                                                    </label>
                                                  </div>
                                                  <div class="file-info">
                                                    <img src="assets/icon/files.svg" class="file-icon" alt="" />
                                                    <div class="file-details">
                                                      <div class="file-name">{{fichier.nom}}</div>
                                                      <div class="file-meta">{{ getFileExtension(fichier.nom) | uppercase}} - {{formatFileSize(fichier.taille)}} - {{formatFileDate(fichier.dateCreation)}}</div>
                                                    </div>
                                                  </div>
                                                  <div class="file-actions btn-actions">
                                                    @if (checkIfFileCanBePreview(fichier)) {
                                                      <button  class="tertiary-button" title="Visualiser" (click)="openFileInNewWindow(fichier, $event, etape.workflowEtapeInstanceId)">
                                                        <img src="assets/icon/Visible.svg" alt="Visualiser" />
                                                      </button>
                                                    }
                                                    <button class="primary-button" (click)="downloadFile(fichier,etape.workflowEtapeInstanceId)">
                                                      <img src="assets/icon/download-white.svg" alt="Download" />
                                                    </button>
                                                    <button class="secondary-button" title="Renommer" (click)="renameFile(fichier, etape.workflowEtapeInstanceId)">
                                                      <img src="assets/icon/pencil.svg" alt="Edit" />
                                                    </button>
                                                    <button class="tertiary-button" title="Supprimer" (click)="deleteFile(fichier, etape.workflowEtapeInstanceId)">
                                                      <img src="assets/icon/delete.svg" alt="Delete" />
                                                    </button>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                                <!-- Affichage des fichiers directs (si pas de sous-dossiers ou en plus) -->
                                @if (dossier.fichiers && dossier.fichiers.length > 0) {
                                  <div class="direct-files">
                                    @for (fichier of dossier.fichiers; track fichier) {
                                      <div class="file-card">
                                        <div class="file-checkbox">
                                          <label class="checkbox-container">
                                            <input type="checkbox"
                                              [checked]="isItemSelected('file', fichier.fichierId, etape.workflowEtapeInstanceId)"
                                              (change)="toggleItemSelection('file', fichier.fichierId, etape.workflowEtapeInstanceId, $event)">
                                              <span class="checkmark"></span>
                                            </label>
                                          </div>
                                          <div class="file-info">
                                            <img src="assets/icon/files.svg" class="file-icon" alt="" />
                                            <div class="file-details">
                                              <div class="file-name">{{fichier.nom}}</div>
                                              <div class="file-meta">{{ getFileExtension(fichier.nom) | uppercase}} - {{formatFileSize(fichier.taille)}} - {{formatFileDate(fichier.dateCreation)}}</div>
                                            </div>
                                          </div>
                                          <div class="file-actions btn-actions">
                                            @if (checkIfFileCanBePreview(fichier)) {
                                              <button  class="tertiary-button" title="Visualiser" (click)="openFileInNewWindow(fichier, $event, etape.workflowEtapeInstanceId)">
                                                <img src="assets/icon/Visible.svg" alt="Visualiser" />
                                              </button>
                                            }
                                            <button class="primary-button" (click)="downloadFile(fichier,etape.workflowEtapeInstanceId)">
                                              <img src="assets/icon/download-white.svg" alt="Download" />
                                            </button>
                                            <button class="secondary-button" title="Renommer" (click)="renameFile(fichier, etape.workflowEtapeInstanceId)">
                                              <img src="assets/icon/pencil.svg" alt="Edit" />
                                            </button>
                                            <button class="tertiary-button" title="Supprimer" (click)="deleteFile(fichier, etape.workflowEtapeInstanceId)">
                                              <img src="assets/icon/delete.svg" alt="Delete" />
                                            </button>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Input file caché pour l'upload -->
          <input #fileInput type="file" multiple style="display: none;" (change)="filesFromInput($event)" accept="*/*" />

          <div bsModal #modalFormDossier="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title pull-left">{{'FILE_EXPLORER.AJOUT_DOSSIER' | translate}}</h4>
                  <button type="button" class="close pull-right" aria-label="Close" (click)="modalFormDossier.hide()">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form (ngSubmit)="addFolder($event)">
                    <div class="form-group">
                      <label for="nomDossier">{{'GLOBAL.NOM' | translate}}</label>
                      <input type="text" class="form-control" name="nomDossier" id="nomDossier" maxlength="50" />
                      @if (folderNameError()) {
                        <div class="custom-alert custom-alert-sm" [innerHTML]="'FILE_EXPLORER.CARACTERES_SPECIAUX' | translate" style="white-space: pre-line;"></div>
                      }
                      @if (folderNameRequired()) {
                        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
                      }
                      @if (folderNameExists()) {
                        <div class="custom-alert custom-alert-sm">{{'FILE_EXPLORER.DOSSIER_EXISTANT' | translate }}</div>
                      }
                    </div>
                    <div class="btn-toolbar justify-content-between">
                      <div class="btn-group" role="group">
                        <button type="submit" class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>
                      </div>
                      <div class="btn-group" role="group">
                        <button type="button" class="btn btn-secondary" (click)="modalFormDossier.hide()">{{'GLOBAL.FERMER' | translate}}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div bsModal #modalRenommer="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title pull-left">{{'FILE_EXPLORER.RENOMMER' | translate}}</h4>
                  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRenommer.hide()">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form (ngSubmit)="rename($event)">
                    <div class="form-group">
                      <label for="newName">{{'GLOBAL.NOM' | translate}}</label>
                      <input type="text" class="form-control" [(ngModel)]="newName" name="newName" id="newName" maxlength="50" />
                      @if (renameNameError()) {
                        <div class="custom-alert custom-alert-sm" [innerHTML]="'FILE_EXPLORER.CARACTERES_SPECIAUX' | translate" style="white-space: pre-line;"></div>
                      }
                      @if (renameNameRequired()) {
                        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
                      }
                    </div>
                    <div class="btn-toolbar justify-content-between">
                      <div class="btn-group" role="group">
                        <button type="submit" class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>
                      </div>
                      <div class="btn-group" role="group">
                        <button type="button" class="btn btn-secondary" (click)="modalRenommer.hide()">{{'GLOBAL.FERMER' | translate}}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="modal-body text-center">
                  <div>
                    <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
                  </div>
                  <button type="button" class="btn btn-primary" (click)="deleteItems()">{{'GLOBAL.OUI' | translate}}</button>
                  <button type="button" class="btn btn-secondary" (click)="modalConfirmSuppr.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
                </div>
              </div>
            </div>
          </div>

          <div bsModal #modalConfirmUpload="bs-modal" class="modal fade upload-modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="popup-model popup-lg shadow top">
              <div class="d-flex justify-content-between align-items-center pink-header P-2">
                <h5 class="flex-grow-1 text-center mt-1">Add Files</h5>
                <div data-svg-wrapper style="position: relative" class="p-1">
                  <button class="btn p-0 d-flex align-items-center" (click)="hideModalConfirmUpload()">
                    <img src="assets/icon/close.svg" />
                  </button>
                </div>
              </div>
              <div class="p-4 scrollable-container">

                <!-- Scrollable Content Container -->
                <div class="upload-modal-content-scroll">

                  <!-- Drag and Drop Zone -->
                  <div class="drag-drop-zone"
                    [ngClass]="{'drag-over': isDragOver}"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)"
                    (click)="triggerFileInput()">
                    <div class="drag-drop-content">
                      <i class="fas fa-cloud-upload-alt fa-3x mb-3"></i>
                      <p class="mb-2 drag-text"><strong>{{'GENERAL_TAB.DRAG_AND_DROP' | translate}}</strong></p>
                      <p class="text-muted">{{'GENERAL_TAB.CLICK_TO_SELECT' | translate}}</p>
                    </div>
                  </div>

                  <!-- File List -->
                  @if (files() && files().length > 0) {
                    <div class="file-list-section">
                      <div class="file-list-header">
                        <h5 class="mt-4 mb-3">{{'GENERAL_TAB.SELECTED_FILES' | translate}} ({{files().length}})</h5>
                        <div class="select-all-section">
                          <label class="checkbox-container">
                            <input type="checkbox"
                              [checked]="areAllFilesSelected()"
                              [indeterminate]="areSomeFilesSelected()"
                              (change)="toggleSelectAllFiles($event)">
                              <span class="checkmark"></span>
                              <span class="checkbox-label">{{'GENERAL_TAB.SELECT_ALL' | translate}}</span>
                            </label>
                          </div>
                        </div>
                        <div class="file-list">
                          @for (file of files(); track file; let i = $index) {
                            <div class="file-item">
                              <div class="file-checkbox">
                                <label class="checkbox-container">
                                  <input type="checkbox"
                                    [checked]="isFileSelected(i)"
                                    (change)="toggleFileSelection(i, $event)">
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                                <div class="file-info">
                                  <img src="assets/icon/files.svg" alt=""/>
                                  <div class="file-details">
                                    <div class="file-name">{{file.name}}</div>
                                    <div class="file-size">{{formatFileSize(file.size)}}</div>
                                  </div>
                                </div>
                                <div class="file-folder-select">
                                  <select
                                    class="form-control form-control-sm"
                                    [(ngModel)]="fileDestinations()[i]"
                                    [disabled]="isFileSelected(i)"
                                    [class.disabled-select]="isFileSelected(i)">
                                    @if (!isFileSelected(i)) {
                                      @for (folder of getAvailableFolders(); track folder) {
                                        <option [value]="folder.dossierId">
                                          {{folder.nom}}
                                        </option>
                                      }
                                    }
                                    @if (isFileSelected(i)) {
                                      <option [value]="null" disabled>{{'GENERAL_TAB.USE_GLOBAL_SELECTION' | translate}}</option>
                                    }
                                  </select>
                                </div>
                                <div class="file-actions">
                                  <button type="button" class="tertiary-button" (click)="removeFile(i)">
                                    <img src="assets/icon/delete.svg" alt="Delete" />
                                  </button>
                                </div>
                              </div>
                            }
                          </div>
                          <div class="total-size mt-3">
                            <strong>Total Size: {{formatFileSize(totalSize())}}</strong>
                          </div>
                          <!-- Duplicate File Warning -->
                          @if (warningDuplicateFile()) {
                            <div class="alert alert-warning mt-3" role="alert">
                              <i class="fas fa-exclamation-triangle"></i>
                              {{'GENERAL_TAB.DUPLICATE_FILE_WARNING' | translate}}
                            </div>
                          }
                        </div>
                      }

                      <!-- Global Folder Selection for Selected Files -->
                      @if (files() && files().length > 0 && getSelectedFiles().length > 0) {
                        <div class="folder-selection mt-4">
                          <div class="form-group">
                            <label for="folderSelect"> {{'GENERAL_TAB.FOLDER_FOR_ALL_SELECTED_FILES' | translate}} ({{getSelectedFiles().length}} {{'GENERAL_TAB.SELECTED' | translate}}):</label>
                            <select class="form-control" id="folderSelect" [(ngModel)]="selectedFolderId" (ngModelChange)="applyFolderToSelected()">
                              <!-- <option [value]="null">Root folder of this step</option> -->
                              @for (folder of getAvailableFolders(); track folder) {
                                <option [value]="folder.dossierId">
                                  {{folder.nom}}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      }

                    </div> <!-- End of scrollable content -->

                  </div> <!-- End of modal-body -->

                  <!-- Fixed Footer with Action Buttons -->
                  @if (files() && files().length > 0) {
                    <div class="modal-footer upload-modal-footer">
                      <button type="button" class="btn btn-primary" (click)="uploadSelectedFiles()">
                        <i class="fas fa-upload"></i>
                        {{'GENERAL_TAB.UPLOAD_ALL' | translate}} {{files().length}} {{'GENERAL_TAB.FILES' | translate}}
                      </button>
                      <button type="button" class="btn btn-secondary ml-2" (click)="hideModalConfirmUpload()">
                        {{'GENERAL_TAB.CANCEL' | translate}}
                      </button>
                    </div>
                  }

                  <!-- Empty State Footer -->
                  @if (!files() || files().length === 0) {
                    <div class="pb-5">
                      <div class="empty-state text-center w-100">
                        <p class="text-muted mb-3">{{'GENERAL_TAB.NO_FILES_SELECTED' | translate}}</p>
                        <button type="button" class="btn btn-secondary" (click)="hideModalConfirmUpload()">
                          {{'GENERAL_TAB.CANCEL' | translate}}
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>

              <div bsModal #modalUpload="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
                <div class="modal-dialog h-100">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h4 class="modal-title pull-left not-selectable">{{'FILE_EXPLORER.TRANSFERT' | translate}}</h4>
                    </div>
                    <div class="modal-body">
                      <div class="text-center">{{'FILE_EXPLORER.AVANCEMENT' | translate}} : {{ progress() }}</div>
                      <div class="progressbar-overlay">
                        <div class="progress">
                          <div class="progress-bar" id="progressbar" role="progressbar" [attr.aria-valuenow]="barProgress()" aria-valuemin="0" aria-valuemax="100" [style.width.%]="barProgress()">{{ progress() }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div bsModal #modalDownload="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h4 class="modal-title pull-left not-selectable">{{'FILE_EXPLORER.TELECHARGEMENT' | translate}}</h4>
                    </div>
                    <div class="modal-body">
                      <div class="text-center not-selectable">{{'FILE_EXPLORER.PREPARATION_TELECHARGEMENT' | translate}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div bsModal #modalFichiersSupprimes="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h4 class="modal-title pull-left not-selectable">{{'FILE_EXPLORER.TELECHARGEMENT' | translate}}</h4>
                    </div>
                    <div class="modal-body text-center">
                      <div class="text-center not-selectable">{{'FILE_EXPLORER.CONFIRM_SUPPR_REF_MORTES' | translate}}</div>
                      <button type="button" class="btn btn-primary" (click)="removeDeadReferences()">{{'GLOBAL.OUI' | translate}}</button>
                      <button type="button" class="btn btn-secondary" (click)="modalFichiersSupprimes.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>

              <div bsModal #modalErreurSynchro="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h4 class="modal-title pull-left not-selectable">{{isRenamingError() ? ('FILE_EXPLORER.RENOMMER' | translate) : ('FILE_EXPLORER.DEPLACEMENT' | translate)}}</h4>
                    </div>
                    <div class="modal-body text-center">
                      <div class="text-center not-selectable">{{isRenamingError() ? ('FILE_EXPLORER.FICHIER_RENOMME_SUPPR' | translate) : ('FILE_EXPLORER.REP_DEST_SUPPR' | translate)}}</div>
                      <button type="button" class="btn btn-primary" (click)="modalErreurSynchro.hide()">{{'GLOBAL.OK' | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
